import type { ReactElement } from "react";
import { MetricWidget } from "./MetricWidget";

/**
 * Activation % (ISSUE-352 AC2) — sourced from ISSUE-350's activation/retention
 * endpoint, still To Do as of 2026-09-03, so this renders the shared
 * not-yet-available placeholder until that endpoint ships.
 */
export function ActivationMetricWidget(): ReactElement {
  return (
    <MetricWidget
      title="Activation"
      unavailableReason="Sourced from ISSUE-350's activation/retention endpoint, which has not shipped yet."
    />
  );
}
